import { PcbNodeTypes, isCopperLayer, matchLayerIdentifier, } from "@buildwithflux/models";
import { isDevEnv, isTestEnv } from "@buildwithflux/shared";
export function netHasTraceOnLayer(net, treeNodes, layer) {
    const routes = getRouteSegmentsForNet(net, treeNodes);
    const traceLayers = routes.map((route) => route.bakedRules.layer);
    return Boolean(isCopperLayer(layer) &&
        traceLayers.some((layerId) => layerId === "All" || matchLayerIdentifier(layer, layerId)));
}
// Unit timestamp for 2023-05-25T04:00:00
const DOCUMENT_NET_MIGRATE_EPOCH = 1684962000;
export function shouldMigrateNetsOnDocumentLoad(document) {
    if (isDevEnv() || isTestEnv()) {
        return true;
    }
    return !!document.created_at && new Date(document.created_at ?? 0).getTime() > DOCUMENT_NET_MIGRATE_EPOCH;
}
export const getRouteSegmentsForNet = (net, nodes) => {
    const children = net.childUids.map((uid) => nodes[uid]);
    return children.filter((node) => node && node.type === PcbNodeTypes.routeSegment);
};
//# sourceMappingURL=helpers.js.map